import * as React from 'react';
import { useTheme } from '@mui/material/styles';

import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Paper from '@mui/material/Paper';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import * as Bs4Utils from '../Bs4Components/Bs4Utils'
import Bs4ReportViewIcon from './Bs4ReportViewIcon'
import { SmallScreenContext } from '../Bs4Theme/Bs4UxTemplates';
import Bs4MainDispatch from '../Bs4MainDispatch'


const VISIBILITY_VISIBLE = 'visible';
const VISIBILITY_HIDDEN = 'hidden';

const DatePicker = (props) => {
  // const theme = useTheme()
  const SELECTION_STATE_OK = 'finish';
  const [value, setValue] = React.useState(props.value || new Date())  
  
  const handleChangeCalendar = (newValue, selectionState, selectedView) => {
    setValue(newValue);
    if (selectionState === SELECTION_STATE_OK && props.onChange) props.onChange(newValue);
  };

  const handleChangeNaw = (event) => {
    handleChangeCalendar(new Date(), SELECTION_STATE_OK) 
  };

  const [xx, xxXX] = Bs4MainDispatch.useBs4Locale();

  return (                
    <LocalizationProvider 
      dateAdapter={AdapterDateFns} 
      adapterLocale={xx}
      localeText={xxXX.components.MuiLocalizationProvider.defaultProps.localeText}
    >                
      <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
        <DateCalendar 
          value={value}
          format="yyyy-MM-dd"
          views={['year', 'month', 'day']}
          onChange={handleChangeCalendar}          
        />
        <Stack direction="row" justifyContent='flex-end' alignItems="center" spacing={1} sx={{width: '100%', p: 1}}>
          <Button onClick={handleChangeNaw}>{xxXX.components.MuiLocalizationProvider.defaultProps.localeText.todayButtonLabel}</Button>
        </Stack>
      </Stack>
    </LocalizationProvider>              
  )
}

const ViewButtons = (props) => {  

  const handleChange = (e, value) => {
    if (props.alwaysChosen && !value) return;
    if (props?.onChange) props.onChange(e, value);    
    if (props.onCloseClick) props.onCloseClick(e);
  }

  if (!props.buttons || props.buttons.length === 0) return null;

  return (
    <ToggleButtonGroup 
      // orientation={props.vertical ? 'vertical' : 'horizontal'} 
      value={props.value} 
      exclusive={props.exclusive} 
      onChange={handleChange} 
      variant='contained' 
      size='small'
    >
      {!props.hideIfOnlyOne || props.buttons.length > 1 || true
      ? 
        props.buttons?.map(view => (
          <ToggleButton key={view.viewType} value={view.viewType}>{view.name}</ToggleButton>
        )) 
      : 
        null
      }
    </ToggleButtonGroup>
  );
}

const ViewNavigation = (props) => {
  const [anchorElDate, setAnchorElData] = React.useState(null);    

  const visibility = React.useMemo(() => {
    return (props.moveYear && props.visibility) ? VISIBILITY_VISIBLE : VISIBILITY_HIDDEN;
  }, [props.moveYear, props.visibility])
   
  React.useEffect(() => {

  }, [])
  
  const handleClickOpen = (event) => {
    setAnchorElData(event.currentTarget);
  };

  const handleDateChange = (newValue) => {      
    setAnchorElData(null);
    if (props.onDataChange) props.onDataChange(newValue);    
  }

  const handlePopoverClose = (e) => {
    setAnchorElData(null);
  }

  return (
    <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
      <IconButton onClick={props.previousYear} sx={{visibility: visibility}}><i className='fa-solid fa-angles-left'></i></IconButton>
      <IconButton onClick={props.previousPeriod}><i className='fa-solid fa-angle-left'></i></IconButton>        
      <Button variant='text' onClick={handleClickOpen}>{Bs4Utils.toDate(props.date)}</Button>
      <IconButton onClick={props.nextPeriod}><i className='fa-solid fa-angle-right'></i></IconButton>
      <IconButton onClick={props.nextYear} sx={{visibility: visibility}}><i className='fa-solid fa-angles-right'></i></IconButton>
      <Popover 
        open={Boolean(anchorElDate)} 
        anchorEl={anchorElDate} 
        //placement='top-start'
        anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        transformOrigin={{vertical: 'bottom', horizontal: 'center'}}
        onClose={handlePopoverClose}
      >
        <Paper>
          <DatePicker value={props.date} onChange={handleDateChange}/>      
        </Paper>
      </Popover>
    </Stack>      
  )
}  

export const Bs4ReportViewFooter = (props) => {
  const smallScreen = React.useContext(SmallScreenContext);
  if (smallScreen) return <ViewFooterSmallScreen {...props}/>

  return (
    <Stack 
      width='100%'
      direction="row" 
      justifyContent="space-between" 
      alignItems="center" 
      spacing={1} 
      p={1} 
      sx={props.sx}
    >   
      <ViewButtons buttons={props.footerButtons} value={props.viewType} exclusive onChange={props.onChangeViewType} alwaysChosen hideIfOnlyOne/>
      <ViewNavigation {...props.slotProps?.navigation}/>
      <ViewButtons buttons={props.footerButtonsOther} value={props.viewType} exclusive onChange={props.onChangeViewType} alwaysChosen/>
      <ViewButtons buttons={props.footerButtonsModifier} value={props.modifiers} onChange={props.onChangeSettings}/>            
      <Bs4ReportViewIcon {...props.slotProps?.reportIcon} />      
    </Stack>      
  )
}

export const ViewFooterSmallScreen = (props) => {
  const ref = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const viewName = React.useMemo(() => {
    const view = props.footerButtons?.find(view => view.viewType === props.viewType);
    if (view) return view.name;
    const viewOther = props.footerButtonsOther?.find(view => view.viewType === props.viewType);
    if (viewOther) return viewOther.name;
    return props.viewType
  }, [props.viewType])


  const handleClickMenu = (e, value) => {    
    props?.onChangeViewType(e, value);
    setOpen(false);
  }

  const handleClickMenuMul = (e, value) => {
    props?.onChangeSettings(e, value);
    setOpen(false);
  }

  const handleOpenMenu = (e) => {
    setOpen(true);
  }

  const handleCloseMenu = (e) => {
    setOpen(false);
  }

  return (
    <Stack 
      width='100%'
      direction="row" 
      // justifyContent="space-between" 
      justifyContent="flex-start" 
      alignItems="center" 
      spacing={1} 
      p={1} 
      sx={props.sx}
    >
      <Button ref={ref} variant='outlined' onClick={handleOpenMenu}>
        {viewName}
        <KeyboardArrowDownIcon/>
      </Button>
      <Popover 
        open={open} 
        anchorEl={ref.current} 
        anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        transformOrigin={{vertical: 'bottom', horizontal: 'center'}}
        onClose={handleCloseMenu}
      >
        <Paper sx={{p: 1}}>
          <Stack direction="column" justifyContent="flex-start" alignItems="stretch" spacing={1}>              
            <ViewButtons buttons={props.footerButtons} value={props.viewType} exclusive onChange={props.onChangeViewType} vertical onCloseClick={handleCloseMenu} alwaysChosen hideIfOnlyOne/>
            <ViewButtons buttons={props.footerButtonsOther} value={props.viewType} exclusive onChange={props.onChangeViewType} vertical onCloseClick={handleCloseMenu} alwaysChosen/>
            <ViewButtons buttons={props.footerButtonsModifier} value={props.modifiers} onChange={props.onChangeSettings} vertical onCloseClick={handleCloseMenu}/>
            <Bs4ReportViewIcon {...props.slotProps?.reportIcon} onCloseClick={handleCloseMenu}/>
          </Stack>      
        </Paper>
      </Popover>
      
      <ViewNavigation {...props.slotProps?.navigation}/>      
    </Stack>      
  )
}  

export default Bs4ReportViewFooter;